import { ASSETS } from "src/constants/cdnConstants"

export const stationDesignDummyData = {
  url: ASSETS.TOUR.STATION_DESIGN.URL,
  study: {
    id: 183,
    is_deleted: false,
    deleted_at: null,
    time_created: '2024-02-12T10:09:27.224745Z',
    study_name: null,
    thumbnail_path: '',
    part_no: 'netgear box',
    user_input: null,
    process_suggestion: {
      response1:
        'Based on the provided data, there are several suggestions that can be made to improve the manufacturing process:\n\n1. Minimize unnecessary non value-add steps: The assessment for Step 3 is labeled as "Necessary non value-add". This suggests that there may be steps in the process that are necessary but do not add value to the final product. Identify such steps and find ways to minimize their impact on the overall process to shorten the manufacturing time.\n\n2. Reduce haphazard hand motion: The hand motion type for Steps 5, 6, and 7 are labeled as "haphazard". This indicates that there may be inefficiencies in the way the worker is moving their hands during these steps, leading to slower manufacturing times. Finding ways to streamline these motions, such as using jigs or fixtures, can help to make the process more efficient.\n\n3. Optimize hand distance travelled: The distance travelled for Steps 5, 6, and 7 are relatively large compared to other steps. This indicates that there may be opportunities to optimize the layout of the work environment and improve the ergonomics for the worker to minimize the amount of hand travel required for these steps.\n\n4. Identify potential automation opportunities: Analyzing the therblig actions for each step can help to identify opportunities for automation. For example, Steps 3, 4, and 5 involve a lot of movement and manipulation of objects. Consider how automation and robotics can be used to perform these tasks more efficiently and precisely.\n\n5. Improve worker training: Given the different assessment types for each step, it may be beneficial to assess worker performance and provide training to optimize their movements and increase efficiency.\n\n6. Regularly review and optimize the manufacturing process: Lastly, it\'s important to continuously review and optimize the manufacturing process to identify and address any inefficiencies. By analyzing data, identifying potential improvements, and implementing changes, the overall efficiency of the manufacturing process can be improved.',
      response2:
        "For step_3(Pick 3 components from Bin 3): \n- Consider analyzing the actions that are labeled as 'Necessary non value-add' and see if any of them can be optimized or eliminated to improve efficiency.\n\nFor step_4(Place 3 components and pick roller):\n- As the comments indicate that this step is 'Value-add', it might be worth considering if any tasks or actions can be added to further increase the value of this step.\n\nFor step_5(Install roller):\n- Since this step has a mix of both 'Value-add' and 'Necessary non value-add' actions, it would be beneficial to analyze the processes and identify tasks that can be optimized or eliminated to improve efficiency and reduce wasted time.\n\nFor step_6(Pick 3 components from Bin 2):\n- There are very few comments for this step, so it might be worth re-evaluating the processes at this step to see if there are any areas for improvement.\n\nFor step_7(Place screw and hand tighten):\n- Similar to step_4(Place 3 components and pick roller), as the comments indicate that this step is mainly 'Value-add', consider if there any additional actions or tasks that can be added to increase the value of this step.\n\nFor step_8(Hand tighten screw):\n- Since there is only one comment for this step, it might be worth doing an analysis to see if there are any potential areas for improvement or optimization.\n\nFor step_1(Place unit on the table and Pick plate) and step_2(Install plate and add 1 screw):\n- As both of these steps are labeled as 'Value-add', it might be worth doing an analysis to identify any potential tasks or actions that can be added or optimized to increase the value of these steps."
    },
    progress: 0,
    created_by: 150,
    deleted_by: null,
    organization: 'retrocausal',
    station: {
      id: 1138,
      is_deleted: false,
      deleted_at: null,
      name: 'test netgear laiba',
      operator: 'Operator 1',
      balance_copies: 1,
      piece_per_cycle: 5,
      no_of_steps: 8,
      created_by: 150,
      deleted_by: null,
      organization: 'retrocausal',
      no_of_work_regions: 1,
      no_of_work_cycles: 1
    },
    file: {
      id: 527,
      is_deleted: false,
      deleted_at: null,
      name: 'Netgear Assembly 2.cycles.mp4',
      description: null,
      created: '2024-02-01T11:17:17.238243Z',
      location: 'file_manager/Netgear Assembly 2.cycles.mp4',
      meta: {
        fps: '29.83',
        size: '323740727',
        type: 'video',
        codec: 'h264',
        width: 1920,
        height: 1080,
        duration: '144.367633'
      },
      thumbnail: ASSETS.TOUR.STATION_DESIGN.STUDY.FILE.THUMBNAIL,
      created_by: 150,
      deleted_by: null,
      organization: 'retrocausal',
      folder: null,
      process: {
        id: 1619,
        progress: 100,
        description: '',
        process: 6,
        status: 2,
        completed_status: 2
      },
      tag: []
    },
    processes: [
      {
        id: 1755,
        progress: 100,
        description: '',
        process: {
          id: 1,
          name: 'Segmentation'
        },
        status: {
          id: 2,
          name: 'Finished'
        },
        completed_status: {
          id: 2,
          name: 'Finished'
        }
      },
      {
        id: 1756,
        progress: 100,
        description: '',
        process: {
          id: 2,
          name: 'Classification'
        },
        status: {
          id: 2,
          name: 'Finished'
        },
        completed_status: {
          id: 2,
          name: 'Finished'
        }
      },
      {
        id: 1757,
        progress: 100,
        description: '',
        process: {
          id: 3,
          name: 'Hand Tracking'
        },
        status: {
          id: 2,
          name: 'Finished'
        },
        completed_status: {
          id: 2,
          name: 'Finished'
        }
      },
      {
        id: 1758,
        progress: 100,
        description: '',
        process: {
          id: 4,
          name: 'Ergonomics'
        },
        status: {
          id: 2,
          name: 'Finished'
        },
        completed_status: {
          id: 2,
          name: 'Finished'
        }
      },
      {
        id: 1759,
        progress: 100,
        description: '',
        process: {
          id: 5,
          name: 'Segments Mapping'
        },
        status: {
          id: 2,
          name: 'Finished'
        },
        completed_status: {
          id: 2,
          name: 'Finished'
        }
      }
    ]
  },
  workRegionsData: [
    {
      color: '#34568B',
      isMarking: true,
      loc_operator: true,
      lineDistance: null,
      key: 0,
      id: 62,
      name: '2fdb7be5-7a91-439d-b281-b375b2119a99',
      isMaster: true
    }
  ],
  operatorMarker: {
    '7cd774cc-796a-40ae-aad6-dc08e5584be5': {
      "x": 314.0416717529297,
      "y": 2.2222137451171875
    }
  },
  regionLines: {
    '6676a3cf-aa05-4a66-8006-c07ea3c2e792': [
      {
        id: '789e04bf-65c2-4ebb-b732-21ed5c2e5c0e',
        x: 570.1944427490234,
        y: 36.22221374511719,
        color: '#34568B',
        angle: 180,
        isMaster: true,
        width: 483,
        index: 1
      },
      {
        id: 'cdcb271d-b4ee-4b82-828c-48e6425b9b49',
        x: 88,
        y: 35,
        color: '#34568B',
        angle: 90,
        isMaster: true,
        width: 416,
        index: 2
      },
      {
        id: 'e9e49129-c04b-4c84-8da3-8bc4e0ca574a',
        x: 84.19444274902344,
        y: 450.22221374511724,
        color: '#34568B',
        angle: 0,
        isMaster: true,
        width: 486,
        index: 3
      },
      {
        color: '#34568B',
        id: '2878a799-1ea2-4b6c-8ad3-cda48cd06e10',
        x: 569.1944427490234,
        y: 451.2222137451172,
        width: 416,
        angle: 270,
        index: 4,
        isMaster: true
      }
    ]
  },
  workAreaPoints: {
    "10876f52-32f2-48e7-8977-f19353cb5761": [
      {
        "x": 570.1944427490234,
        "y": 36.22221374511719
      },
      {
        "x": 88,
        "y": 35
      },
      {
        "x": 84.19444274902344,
        "y": 450.22221374511724
      },
      {
        "x": 569.1944427490234,
        "y": 451.2222137451172
      }
    ]
  },
  selectedSegment: 9,
  stepsAnalysis: [
    {
      id: 11147,
      name: 'Place unit on the table and Pick plate',
      segment_start: 59,
      segment_end: 250,
      step_index: 0,
      stopclock_time: 6.4,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: true,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11146,
          name: 'Hand tighten screw',
          segment_start: 1872,
          segment_end: 1974,
          step_index: 7,
          stopclock_time: 3.42,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11144]
        }
      ],
      step_action_association: [
        {
          id: 3486,
          value_type: 'Value-add',
          step: 11147,
          action: 3,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3486,
          value_type: 'Value-add',
          step: 11147,
          action: 3,
          answers: []
        }
      ]
    },
    {
      id: 11148,
      name: 'Install plate and add 1 screw',
      segment_start: 252,
      segment_end: 630,
      step_index: 1,
      stopclock_time: 12.67,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11147,
          name: 'Place unit on the table and Pick plate',
          segment_start: 59,
          segment_end: 250,
          step_index: 0,
          stopclock_time: 6.4,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: true,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11146]
        }
      ],
      step_action_association: [
        {
          id: 3488,
          value_type: 'Value-add',
          step: 11148,
          action: 3,
          answers: []
        },
        {
          id: 3487,
          value_type: 'Value-add',
          step: 11148,
          action: 4,
          answers: []
        },
        {
          id: 3489,
          value_type: 'Value-add',
          step: 11148,
          action: 7,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3488,
          value_type: 'Value-add',
          step: 11148,
          action: 3,
          answers: []
        },
        {
          id: 3487,
          value_type: 'Value-add',
          step: 11148,
          action: 4,
          answers: []
        },
        {
          id: 3489,
          value_type: 'Value-add',
          step: 11148,
          action: 7,
          answers: []
        }
      ]
    },
    {
      id: 11140,
      name: 'Pick 3 components from Bin 3',
      segment_start: 631,
      segment_end: 715,
      step_index: 2,
      stopclock_time: 2.82,
      action_type: 'Manual',
      value_type: 'Necessary non value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 8353,
          name: 'fit comp 1',
          segment_start: 5364,
          segment_end: 5558,
          step_index: 10,
          stopclock_time: 6.48,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 44,
          parent_step: null,
          predecessor: [8351]
        }
      ],
      step_action_association: [
        {
          id: 3468,
          value_type: null,
          step: 11140,
          action: 3,
          answers: []
        },
        {
          id: 3467,
          value_type: null,
          step: 11140,
          action: 4,
          answers: []
        },
        {
          id: 3469,
          value_type: null,
          step: 11140,
          action: 5,
          answers: []
        },
        {
          id: 3450,
          value_type: 'Necessary non value-add',
          step: 11140,
          action: 8,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3468,
          value_type: null,
          step: 11140,
          action: 3,
          answers: []
        },
        {
          id: 3467,
          value_type: null,
          step: 11140,
          action: 4,
          answers: []
        },
        {
          id: 3469,
          value_type: null,
          step: 11140,
          action: 5,
          answers: []
        },
        {
          id: 3450,
          value_type: 'Necessary non value-add',
          step: 11140,
          action: 8,
          answers: []
        }
      ]
    },
    {
      id: 11141,
      name: 'Place 3 components and pick roller',
      segment_start: 716,
      segment_end: 840,
      step_index: 3,
      stopclock_time: 4.16,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11140,
          name: 'Pick 3 components from Bin 3',
          segment_start: 631,
          segment_end: 715,
          step_index: 2,
          stopclock_time: 2.82,
          action_type: 'Manual',
          value_type: 'Necessary non value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [8353]
        }
      ],
      step_action_association: [
        {
          id: 3451,
          value_type: 'Value-add',
          step: 11141,
          action: 4,
          answers: []
        },
        {
          id: 3470,
          value_type: null,
          step: 11141,
          action: 5,
          answers: []
        },
        {
          id: 3471,
          value_type: null,
          step: 11141,
          action: 8,
          answers: []
        },
        {
          id: 3472,
          value_type: null,
          step: 11141,
          action: 12,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3451,
          value_type: 'Value-add',
          step: 11141,
          action: 4,
          answers: []
        },
        {
          id: 3470,
          value_type: null,
          step: 11141,
          action: 5,
          answers: []
        },
        {
          id: 3471,
          value_type: null,
          step: 11141,
          action: 8,
          answers: []
        },
        {
          id: 3472,
          value_type: null,
          step: 11141,
          action: 12,
          answers: []
        }
      ]
    },
    {
      id: 11142,
      name: 'Install roller',
      segment_start: 841,
      segment_end: 1330,
      step_index: 4,
      stopclock_time: 16.39,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11140,
          name: 'Pick 3 components from Bin 3',
          segment_start: 631,
          segment_end: 715,
          step_index: 2,
          stopclock_time: 2.82,
          action_type: 'Manual',
          value_type: 'Necessary non value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [8353]
        }
      ],
      step_action_association: [
        {
          id: 3453,
          value_type: 'Value-add',
          step: 11142,
          action: 3,
          answers: []
        },
        {
          id: 3452,
          value_type: 'Value-add',
          step: 11142,
          action: 4,
          answers: []
        },
        {
          id: 3454,
          value_type: 'Value-add',
          step: 11142,
          action: 7,
          answers: []
        },
        {
          id: 3455,
          value_type: 'Necessary non value-add',
          step: 11142,
          action: 8,
          answers: []
        },
        {
          id: 3473,
          value_type: null,
          step: 11142,
          action: 12,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3453,
          value_type: 'Value-add',
          step: 11142,
          action: 3,
          answers: []
        },
        {
          id: 3452,
          value_type: 'Value-add',
          step: 11142,
          action: 4,
          answers: []
        },
        {
          id: 3454,
          value_type: 'Value-add',
          step: 11142,
          action: 7,
          answers: []
        },
        {
          id: 3455,
          value_type: 'Necessary non value-add',
          step: 11142,
          action: 8,
          answers: []
        },
        {
          id: 3473,
          value_type: null,
          step: 11142,
          action: 12,
          answers: []
        }
      ]
    },
    {
      id: 11143,
      name: 'Pick 3 components from Bin 2',
      segment_start: 1331,
      segment_end: 1601,
      step_index: 5,
      stopclock_time: 9.05,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11141,
          name: 'Place 3 components and pick roller',
          segment_start: 716,
          segment_end: 840,
          step_index: 3,
          stopclock_time: 4.16,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11140]
        }
      ],
      step_action_association: [
        {
          id: 3456,
          value_type: 'Value-add',
          step: 11143,
          action: 3,
          answers: []
        },
        {
          id: 3474,
          value_type: null,
          step: 11143,
          action: 6,
          answers: []
        },
        {
          id: 3475,
          value_type: null,
          step: 11143,
          action: 9,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3456,
          value_type: 'Value-add',
          step: 11143,
          action: 3,
          answers: []
        },
        {
          id: 3474,
          value_type: null,
          step: 11143,
          action: 6,
          answers: []
        },
        {
          id: 3475,
          value_type: null,
          step: 11143,
          action: 9,
          answers: []
        }
      ]
    },
    {
      id: 11144,
      name: 'Place screw and hand tighten',
      segment_start: 1602,
      segment_end: 1871,
      step_index: 6,
      stopclock_time: 9.02,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11143,
          name: 'Pick 3 components from Bin 2',
          segment_start: 1331,
          segment_end: 1601,
          step_index: 5,
          stopclock_time: 9.05,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11141]
        }
      ],
      step_action_association: [
        {
          id: 3458,
          value_type: 'Value-add',
          step: 11144,
          action: 3,
          answers: []
        },
        {
          id: 3457,
          value_type: 'Value-add',
          step: 11144,
          action: 4,
          answers: []
        },
        {
          id: 3477,
          value_type: null,
          step: 11144,
          action: 5,
          answers: []
        },
        {
          id: 3459,
          value_type: 'Value-add',
          step: 11144,
          action: 7,
          answers: []
        },
        {
          id: 3476,
          value_type: null,
          step: 11144,
          action: 8,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3458,
          value_type: 'Value-add',
          step: 11144,
          action: 3,
          answers: []
        },
        {
          id: 3457,
          value_type: 'Value-add',
          step: 11144,
          action: 4,
          answers: []
        },
        {
          id: 3477,
          value_type: null,
          step: 11144,
          action: 5,
          answers: []
        },
        {
          id: 3459,
          value_type: 'Value-add',
          step: 11144,
          action: 7,
          answers: []
        },
        {
          id: 3476,
          value_type: null,
          step: 11144,
          action: 8,
          answers: []
        }
      ]
    },
    {
      id: 11146,
      name: 'Hand tighten screw',
      segment_start: 1872,
      segment_end: 1974,
      step_index: 7,
      stopclock_time: 3.42,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11144,
          name: 'Place screw and hand tighten',
          segment_start: 1602,
          segment_end: 1871,
          step_index: 6,
          stopclock_time: 9.02,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11143]
        }
      ],
      step_action_association: [
        {
          id: 3484,
          value_type: 'Value-add',
          step: 11146,
          action: 7,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3484,
          value_type: 'Value-add',
          step: 11146,
          action: 7,
          answers: []
        }
      ]
    }
  ],
  segmentationData: [
    {
      id: 11147,
      name: 'Place unit on the table and Pick plate',
      segment_start: 59,
      segment_end: 250,
      step_index: 0,
      stopclock_time: 6.4,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: true,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11146,
          name: 'Hand tighten screw',
          segment_start: 1872,
          segment_end: 1974,
          step_index: 7,
          stopclock_time: 3.42,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11144]
        }
      ],
      step_action_association: [
        {
          id: 3486,
          value_type: 'Value-add',
          step: 11147,
          action: 3,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3486,
          value_type: 'Value-add',
          step: 11147,
          action: 3,
          answers: []
        }
      ]
    },
    {
      id: 11148,
      name: 'Install plate and add 1 screw',
      segment_start: 252,
      segment_end: 630,
      step_index: 1,
      stopclock_time: 12.67,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11147,
          name: 'Place unit on the table and Pick plate',
          segment_start: 59,
          segment_end: 250,
          step_index: 0,
          stopclock_time: 6.4,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: true,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11146]
        }
      ],
      step_action_association: [
        {
          id: 3488,
          value_type: 'Value-add',
          step: 11148,
          action: 3,
          answers: []
        },
        {
          id: 3487,
          value_type: 'Value-add',
          step: 11148,
          action: 4,
          answers: []
        },
        {
          id: 3489,
          value_type: 'Value-add',
          step: 11148,
          action: 7,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3488,
          value_type: 'Value-add',
          step: 11148,
          action: 3,
          answers: []
        },
        {
          id: 3487,
          value_type: 'Value-add',
          step: 11148,
          action: 4,
          answers: []
        },
        {
          id: 3489,
          value_type: 'Value-add',
          step: 11148,
          action: 7,
          answers: []
        }
      ]
    },
    {
      id: 11140,
      name: 'Pick 3 components from Bin 3',
      segment_start: 631,
      segment_end: 715,
      step_index: 2,
      stopclock_time: 2.82,
      action_type: 'Manual',
      value_type: 'Necessary non value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 8353,
          name: 'fit comp 1',
          segment_start: 5364,
          segment_end: 5558,
          step_index: 10,
          stopclock_time: 6.48,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 44,
          parent_step: null,
          predecessor: [8351]
        }
      ],
      step_action_association: [
        {
          id: 3468,
          value_type: null,
          step: 11140,
          action: 3,
          answers: []
        },
        {
          id: 3467,
          value_type: null,
          step: 11140,
          action: 4,
          answers: []
        },
        {
          id: 3469,
          value_type: null,
          step: 11140,
          action: 5,
          answers: []
        },
        {
          id: 3450,
          value_type: 'Necessary non value-add',
          step: 11140,
          action: 8,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3468,
          value_type: null,
          step: 11140,
          action: 3,
          answers: []
        },
        {
          id: 3467,
          value_type: null,
          step: 11140,
          action: 4,
          answers: []
        },
        {
          id: 3469,
          value_type: null,
          step: 11140,
          action: 5,
          answers: []
        },
        {
          id: 3450,
          value_type: 'Necessary non value-add',
          step: 11140,
          action: 8,
          answers: []
        }
      ]
    },
    {
      id: 11141,
      name: 'Place 3 components and pick roller',
      segment_start: 716,
      segment_end: 840,
      step_index: 3,
      stopclock_time: 4.16,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11140,
          name: 'Pick 3 components from Bin 3',
          segment_start: 631,
          segment_end: 715,
          step_index: 2,
          stopclock_time: 2.82,
          action_type: 'Manual',
          value_type: 'Necessary non value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [8353]
        }
      ],
      step_action_association: [
        {
          id: 3451,
          value_type: 'Value-add',
          step: 11141,
          action: 4,
          answers: []
        },
        {
          id: 3470,
          value_type: null,
          step: 11141,
          action: 5,
          answers: []
        },
        {
          id: 3471,
          value_type: null,
          step: 11141,
          action: 8,
          answers: []
        },
        {
          id: 3472,
          value_type: null,
          step: 11141,
          action: 12,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3451,
          value_type: 'Value-add',
          step: 11141,
          action: 4,
          answers: []
        },
        {
          id: 3470,
          value_type: null,
          step: 11141,
          action: 5,
          answers: []
        },
        {
          id: 3471,
          value_type: null,
          step: 11141,
          action: 8,
          answers: []
        },
        {
          id: 3472,
          value_type: null,
          step: 11141,
          action: 12,
          answers: []
        }
      ]
    },
    {
      id: 11142,
      name: 'Install roller',
      segment_start: 841,
      segment_end: 1330,
      step_index: 4,
      stopclock_time: 16.39,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11140,
          name: 'Pick 3 components from Bin 3',
          segment_start: 631,
          segment_end: 715,
          step_index: 2,
          stopclock_time: 2.82,
          action_type: 'Manual',
          value_type: 'Necessary non value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [8353]
        }
      ],
      step_action_association: [
        {
          id: 3453,
          value_type: 'Value-add',
          step: 11142,
          action: 3,
          answers: []
        },
        {
          id: 3452,
          value_type: 'Value-add',
          step: 11142,
          action: 4,
          answers: []
        },
        {
          id: 3454,
          value_type: 'Value-add',
          step: 11142,
          action: 7,
          answers: []
        },
        {
          id: 3455,
          value_type: 'Necessary non value-add',
          step: 11142,
          action: 8,
          answers: []
        },
        {
          id: 3473,
          value_type: null,
          step: 11142,
          action: 12,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3453,
          value_type: 'Value-add',
          step: 11142,
          action: 3,
          answers: []
        },
        {
          id: 3452,
          value_type: 'Value-add',
          step: 11142,
          action: 4,
          answers: []
        },
        {
          id: 3454,
          value_type: 'Value-add',
          step: 11142,
          action: 7,
          answers: []
        },
        {
          id: 3455,
          value_type: 'Necessary non value-add',
          step: 11142,
          action: 8,
          answers: []
        },
        {
          id: 3473,
          value_type: null,
          step: 11142,
          action: 12,
          answers: []
        }
      ]
    },
    {
      id: 11143,
      name: 'Pick 3 components from Bin 2',
      segment_start: 1331,
      segment_end: 1601,
      step_index: 5,
      stopclock_time: 9.05,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11141,
          name: 'Place 3 components and pick roller',
          segment_start: 716,
          segment_end: 840,
          step_index: 3,
          stopclock_time: 4.16,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11140]
        }
      ],
      step_action_association: [
        {
          id: 3456,
          value_type: 'Value-add',
          step: 11143,
          action: 3,
          answers: []
        },
        {
          id: 3474,
          value_type: null,
          step: 11143,
          action: 6,
          answers: []
        },
        {
          id: 3475,
          value_type: null,
          step: 11143,
          action: 9,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3456,
          value_type: 'Value-add',
          step: 11143,
          action: 3,
          answers: []
        },
        {
          id: 3474,
          value_type: null,
          step: 11143,
          action: 6,
          answers: []
        },
        {
          id: 3475,
          value_type: null,
          step: 11143,
          action: 9,
          answers: []
        }
      ]
    },
    {
      id: 11144,
      name: 'Place screw and hand tighten',
      segment_start: 1602,
      segment_end: 1871,
      step_index: 6,
      stopclock_time: 9.02,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11143,
          name: 'Pick 3 components from Bin 2',
          segment_start: 1331,
          segment_end: 1601,
          step_index: 5,
          stopclock_time: 9.05,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11141]
        }
      ],
      step_action_association: [
        {
          id: 3458,
          value_type: 'Value-add',
          step: 11144,
          action: 3,
          answers: []
        },
        {
          id: 3457,
          value_type: 'Value-add',
          step: 11144,
          action: 4,
          answers: []
        },
        {
          id: 3477,
          value_type: null,
          step: 11144,
          action: 5,
          answers: []
        },
        {
          id: 3459,
          value_type: 'Value-add',
          step: 11144,
          action: 7,
          answers: []
        },
        {
          id: 3476,
          value_type: null,
          step: 11144,
          action: 8,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3458,
          value_type: 'Value-add',
          step: 11144,
          action: 3,
          answers: []
        },
        {
          id: 3457,
          value_type: 'Value-add',
          step: 11144,
          action: 4,
          answers: []
        },
        {
          id: 3477,
          value_type: null,
          step: 11144,
          action: 5,
          answers: []
        },
        {
          id: 3459,
          value_type: 'Value-add',
          step: 11144,
          action: 7,
          answers: []
        },
        {
          id: 3476,
          value_type: null,
          step: 11144,
          action: 8,
          answers: []
        }
      ]
    },
    {
      id: 11146,
      name: 'Hand tighten screw',
      segment_start: 1872,
      segment_end: 1974,
      step_index: 7,
      stopclock_time: 3.42,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11144,
          name: 'Place screw and hand tighten',
          segment_start: 1602,
          segment_end: 1871,
          step_index: 6,
          stopclock_time: 9.02,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11143]
        }
      ],
      step_action_association: [
        {
          id: 3484,
          value_type: 'Value-add',
          step: 11146,
          action: 7,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 3484,
          value_type: 'Value-add',
          step: 11146,
          action: 7,
          answers: []
        }
      ]
    }
  ],
  selectedActionQuestions: {
    Elimination: [
      {
        id: 1,
        question: 'Can this step be eliminated?',
        suggestion: 'Eliminate this step.',
        category: 'Elimination',
        cost_saving_percentage: 80,
        action: 3
      },
      {
        id: 10,
        question: 'Can some components in the assembled product be eliminated?',
        suggestion: 'Assess and eliminate unnecessary components in the assembly.',
        category: 'Elimination',
        cost_saving_percentage: 80,
        action: 3
      }
    ],
    Simplification: [
      {
        id: 2,
        question: 'Can distances be shortened to advantage?',
        suggestion: 'Shorten distances for advantage.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 8,
        question:
          'Is time increased because of the nature of the material being moved or because of a subsequent delicate positioning?',
        suggestion:
          'Analyze time factors related to material movement and delicate positioning.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 9,
        question: 'Can abrupt changes in direction be eliminated?',
        suggestion: 'Eliminate abrupt changes in direction.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 14,
        question:
          'Can parts be slid across the work surface rather than carried above the work surface?',
        suggestion: 'Slide parts across the work surface instead of carrying them.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 15,
        question:
          'Could having a lip on the front of any bins holding the components give the hands easier access to the components?',
        suggestion: 'Improve accessibility with front lip on component bins.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 16,
        question: 'Can the components and tools be lighter in weight than now?',
        suggestion: 'Prioritize lightweight components and tools.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 19,
        question:
          'Is the nature of the material being moved a cause for delay during transportation  eg. is anything being dropped or spilled?',
        suggestion: 'Identify and address material-related delays during transportation.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 20,
        question:
          'Is the nature of the material being moved a cause for delay after the transportation is complete eg. is there subsequent need for delicate positioning?',
        suggestion:
          'Address potential delays caused by delicate positioning after transportation.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      },
      {
        id: 21,
        question:
          'Can abrupt changes in direction of movement by the hand(s) and/or body be eliminated or reduced?',
        suggestion: 'Minimize abrupt changes in direction of hand and body movement.',
        category: 'Simplification',
        cost_saving_percentage: 12,
        action: 3
      }
    ],
    Standardization: [
      {
        id: 3,
        question:
          'Could a better device (Tongs? Tweezers?) be used to (manually) handle the components?',
        suggestion: 'Consider a better device for handling components.',
        category: 'Standardization',
        cost_saving_percentage: 19,
        action: 3
      },
      {
        id: 4,
        question:
          'Could a better body member (fingers, wrist, forearm, shoulder) be used here?',
        suggestion: 'Explore better body members for this task.',
        category: 'Standardization',
        cost_saving_percentage: 19,
        action: 3
      }
    ],
    Automation: [
      {
        id: 5,
        question:
          'Could a better transportation option (Gravity Chute? Conveyor? Automation? Robot? Foot-operated device? A karakuri mechanism?) be used here?',
        suggestion: 'Evaluate improved transportation options.',
        category: 'Automation',
        cost_saving_percentage: 22,
        action: 3
      },
      {
        id: 6,
        question: 'Can transports be effected through mechanization and foot-operated devices?',
        suggestion: 'Implement mechanization and foot-operated devices for transportation.',
        category: 'Automation',
        cost_saving_percentage: 22,
        action: 3
      },
      {
        id: 22,
        question:
          'Could a cobot do all transportation (or other work) in parallel with the operator?',
        suggestion: 'Consider integrating a cobot for parallel work with the operator.',
        category: 'Automation',
        cost_saving_percentage: 22,
        action: 3
      }
    ],
    Combination: [
      {
        id: 7,
        question: 'Will time be reduced by transporting in larger units?',
        suggestion: 'Transport in larger units to reduce time.',
        category: 'Combination',
        cost_saving_percentage: 25,
        action: 3
      },
      {
        id: 11,
        question: 'Can some of the components in the assembled product be combined?',
        suggestion: 'Combine certain components in the assembly.',
        category: 'Combination',
        cost_saving_percentage: 25,
        action: 3
      },
      {
        id: 17,
        question:
          'Can both hands be used simultaneously with one hand reaching for (and getting) the tool and the other hand reaching for (and getting) a component?',
        suggestion: 'Promote simultaneous use of both hands for tool and component retrieval.',
        category: 'Combination',
        cost_saving_percentage: 25,
        action: 3
      },
      {
        id: 18,
        question:
          'Could both hands simultaneously reach for (and get) the same components from two bins, one bin on the LHS and the other bin on the RHS of the assembly area?',
        suggestion: 'Implement dual-sided bin setup for efficient component retrieval.',
        category: 'Combination',
        cost_saving_percentage: 25,
        action: 3
      }
    ],
    Rearrangement: [
      {
        id: 12,
        question:
          'Can the reach distances of travel by the hand(s) or the body be shortened by locating components that are used most frequently nearest to their point(s) of use?',
        suggestion:
          'Optimize reach distances by organizing frequently used components closer to their points of use.',
        category: 'Rearrangement',
        cost_saving_percentage: 28,
        action: 3
      },
      {
        id: 13,
        question:
          'Can the reach distances of travel by the hand(s) or the body be shortened by locating tools that are used most frequently nearest to their point(s) of use?',
        suggestion:
          'Optimize reach distances by organizing frequently used tools closer to their points of use.',
        category: 'Rearrangement',
        cost_saving_percentage: 28,
        action: 3
      },
      {
        id: 23,
        question:
          'Could the need for hand-eye coordination when reaching to get the component(s) or tool(s) be reduced?',
        suggestion:
          'Streamline processes to reduce reliance on hand-eye coordination for component and tool retrieval.',
        category: 'Rearrangement',
        cost_saving_percentage: 28,
        action: 3
      }
    ]
  },
  studyAnswers: [
    {
      id: 1799,
      response: 1,
      question: {
        id: 1,
        group: 'FACILITY_RELATED_QUESTION',
        question: 'Are documented standard work instructions accessible to the operator?',
        improvement_on: 0,
        improvement:
          'Consider providing a standard work instruction that is easily accessible at each workstation.',
        follow_up_on: null,
        impact_productivity: false,
        impact_quality: true,
        impact_safety: true
      },
      steps: []
    },
    {
      id: 1800,
      response: 0,
      question: {
        id: 2,
        group: 'FACILITY_RELATED_QUESTION',
        question: 'Are required visual controls and display boards provided?',
        improvement_on: 0,
        improvement:
          'Consider installing the required visual and display boards at workstations.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: true,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1801,
      response: 0,
      question: {
        id: 3,
        group: 'FACILITY_RELATED_QUESTION',
        question:
          'Are operators provided with the necessary tools and equipment as mentioned in the standard work?',
        improvement_on: 0,
        improvement:
          'Ensure that necessary tools and equipments are readily available, as outlined in the SWI.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: true,
        impact_safety: true
      },
      steps: []
    },
    {
      id: 1802,
      response: null,
      question: {
        id: 4,
        group: 'FACILITY_RELATED_QUESTION',
        question: 'Are operators provided with necessary Job/Skill training?',
        improvement_on: 0,
        improvement:
          'Consider conducting a training sessions to equip operators with the necessary skills.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: true,
        impact_safety: true
      },
      steps: []
    },
    {
      id: 1803,
      response: null,
      question: {
        id: 5,
        group: 'OPERATORS_ADHERENCE_TO_STANDARD_WORK',
        question: 'Do operators follow the established sequence consistently?',
        improvement_on: 0,
        improvement:
          'Consider educating and training operators on the significance of adhering to the correct sequence. Or Alternatively, establish a poke-yoke system to prevent incorrect sequencing.',
        follow_up_on: null,
        impact_productivity: false,
        impact_quality: true,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1804,
      response: null,
      question: {
        id: 6,
        group: 'OPERATORS_ADHERENCE_TO_STANDARD_WORK',
        question: 'Do operators perform all the actions in SWI without skipping?',
        improvement_on: 0,
        improvement:
          'Consider educating and training operators on the importance of not skipping steps. Or Alternatively, establish a poke-yoke system to avoid skipping a step.',
        follow_up_on: 'NO',
        impact_productivity: false,
        impact_quality: true,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1805,
      response: null,
      question: {
        id: 7,
        group: 'OPERATORS_ADHERENCE_TO_STANDARD_WORK',
        question:
          'Do operators follow the method established(positioning/alignment) appropriately for each action?',
        improvement_on: 0,
        improvement:
          'Consider educating and training operators on the importance of following a method. Or Alternatively, establish a poke-yoke system.',
        follow_up_on: 'NO',
        impact_productivity: true,
        impact_quality: true,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1806,
      response: null,
      question: {
        id: 8,
        group: 'OPERATORS_ADHERENCE_TO_STANDARD_WORK',
        question: 'Do operators use the provided tool/equipment effectively for each action?',
        improvement_on: 0,
        improvement:
          'Consider providing training to operators on the effective use of tools and equipment.',
        follow_up_on: 'NO',
        impact_productivity: false,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1807,
      response: null,
      question: {
        id: 9,
        group: 'OPERATORS_ADHERENCE_TO_STANDARD_WORK',
        question: 'Do operators use correct parts or components for each product?',
        improvement_on: 0,
        improvement:
          'Consider educating and training operators on the importance of using correct parts. Or Alternatively, establish a poke-yoke system to prevent the mixing of parts.',
        follow_up_on: null,
        impact_productivity: false,
        impact_quality: true,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1808,
      response: null,
      question: {
        id: 10,
        group: 'OPERATORS_ADHERENCE_TO_STANDARD_WORK',
        question: 'Do operators perform cycles within estimated time?',
        improvement_on: 0,
        improvement: 'Consider training operators on efficient work methods and speed.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1809,
      response: null,
      question: {
        id: 11,
        group: 'WORKPLACE_DESIGN',
        question: 'Does required materials get replenished on time with right quantity?',
        improvement_on: 0,
        improvement:
          'Consider implementing a 2-bin system or establishing a replenishment cycle to ensure the right quantity at the right time.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1810,
      response: null,
      question: {
        id: 12,
        group: 'WORKPLACE_DESIGN',
        question:
          'Are standard place provided for every material according to the assembly order?',
        improvement_on: 0,
        improvement:
          'Consider assigning a standard place for each material in the order of assembly.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1811,
      response: null,
      question: {
        id: 13,
        group: 'WORKPLACE_DESIGN',
        question:
          'Is operator able to reach and deposit every materials on workstation comfortably?',
        improvement_on: 0,
        improvement: 'Consider rearranging material bins based on ergonomic suggestions.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: true
      },
      steps: []
    },
    {
      id: 1812,
      response: null,
      question: {
        id: 14,
        group: 'WORKPLACE_DESIGN',
        question:
          'Are standard place provided for every tool or equipment in the assembly order?',
        improvement_on: 0,
        improvement: 'Consider designating a standard place for each tool or equipment.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1813,
      response: null,
      question: {
        id: 15,
        group: 'WORKPLACE_DESIGN',
        question:
          'Is operator able to reach and deposit every tool or equipment on workstation comfortably?',
        improvement_on: 0,
        improvement: 'Consider rearranging tools or equipment based on ergonomic suggestions.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: true
      },
      steps: []
    },
    {
      id: 1814,
      response: null,
      question: {
        id: 16,
        group: 'WORKPLACE_DESIGN',
        question: 'Is lighting and contrast appropriate for the jobs being performed?',
        improvement_on: 0,
        improvement:
          'Ensure adequate lighting and contrast in accordance with job requirements.',
        follow_up_on: null,
        impact_productivity: false,
        impact_quality: true,
        impact_safety: true
      },
      steps: []
    },
    {
      id: 1815,
      response: null,
      question: {
        id: 17,
        group: 'MANUFACTURING_WASTES',
        question:
          'Overproduction:  Is the workstation producing more than the target volume per hour?',
        improvement_on: 1,
        improvement:
          'Consider rebalancing the production line to eliminate or reduce overproduction.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1816,
      response: null,
      question: {
        id: 18,
        group: 'MANUFACTURING_WASTES',
        question:
          'Overproduction:  Are there excessive batch sizes or unnecessary duplication of work?',
        improvement_on: 1,
        improvement: 'Consider rebalancing the line to minimize batch sizes.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1817,
      response: null,
      question: {
        id: 19,
        group: 'MANUFACTURING_WASTES',
        question:
          'Inventory: Is there a surplus of raw materials which is not consumed within a shift?',
        improvement_on: 1,
        improvement:
          'Consider adopting a 2-bin system or establishing a replenishment cycle for timely quantity assurance.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1818,
      response: null,
      question: {
        id: 20,
        group: 'MANUFACTURING_WASTES',
        question:
          'Inventory: Are there more than 2 parts waiting to be processed or assembled?',
        improvement_on: 1,
        improvement: 'Consider reducing or eliminating buffer stocks between stations.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1819,
      response: null,
      question: {
        id: 21,
        group: 'MANUFACTURING_WASTES',
        question: 'Waiting: Is operator waiting for parts from pervious station?',
        improvement_on: 1,
        improvement:
          'Conduct a Root Cause Analysis (RCA) to eliminate operator waiting caused by incoming parts.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1820,
      response: null,
      question: {
        id: 22,
        group: 'MANUFACTURING_WASTES',
        question:
          'Waiting: Is operator waiting for finished goods to move to the next station work?',
        improvement_on: 1,
        improvement: 'Conduct an RCA to eliminate operator waiting caused by bottlenecks.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1821,
      response: null,
      question: {
        id: 23,
        group: 'MANUFACTURING_WASTES',
        question:
          'Waiting: Are there any instances where operator is waiting for machine to complete work?',
        improvement_on: 1,
        improvement:
          'Consider rebalancing the line to eliminate operator waiting due to machine issues.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1822,
      response: null,
      question: {
        id: 24,
        group: 'MANUFACTURING_WASTES',
        question:
          'Waiting: Is operator waiting for any approval or confirmation or information?',
        improvement_on: 1,
        improvement: 'Conduct an RCA to enhance information flow in the system.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1823,
      response: null,
      question: {
        id: 25,
        group: 'MANUFACTURING_WASTES',
        question:
          'Non-utilized talent: Are workers at this workstation fully engaged and utilizing their skills and knowledge effectively?',
        improvement_on: 1,
        improvement: 'Consider automating or eliminating Non-Value-Adding tasks/activities.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1824,
      response: null,
      question: {
        id: 26,
        group: 'MANUFACTURING_WASTES',
        question:
          "Overprocessing:  Are there any steps in the process that don't add value to the final product?",
        improvement_on: 1,
        improvement: 'Consider automating or eliminating Non-Value-Adding tasks/activities.',
        follow_up_on: 'YES',
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1825,
      response: null,
      question: {
        id: 27,
        group: 'MANUFACTURING_WASTES',
        question:
          'Defects:  Are re-works or corrections made often due to defects produced in this station?',
        improvement_on: 1,
        improvement: 'Conduct an RCA to identify and eliminate the root cause of defects.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: true,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1826,
      response: null,
      question: {
        id: 28,
        group: 'MANUFACTURING_WASTES',
        question:
          'Defects: Can you identify any cause of defects or quality issues occurred while performing any of these steps?',
        improvement_on: 1,
        improvement: 'Conduct an RCA to identify and eliminate the root cause of defects.',
        follow_up_on: 'YES',
        impact_productivity: false,
        impact_quality: true,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1827,
      response: null,
      question: {
        id: 29,
        group: 'MANUFACTURING_WASTES',
        question:
          'Transportation: Does operator walk or move often to bring materials or parts?',
        improvement_on: 1,
        improvement: 'Consider rearranging the line layout to reduce unnecessary movements.',
        follow_up_on: 'YES',
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1828,
      response: null,
      question: {
        id: 30,
        group: 'MANUFACTURING_WASTES',
        question:
          'Motion: Does operator move parts or material from one position to another position unnecessarily within the workstation?',
        improvement_on: 1,
        improvement: 'Evaluate the standard method and remove any unnecessary movements.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    },
    {
      id: 1829,
      response: null,
      question: {
        id: 31,
        group: 'MANUFACTURING_WASTES',
        question:
          'Motion: Are visual aids such as monitor placed at incorrect heights or angles, causing operators to constantly adjust their gaze?',
        improvement_on: 1,
        improvement: 'Consider rearranging equipment and tools based on ergonomic suggestions.',
        follow_up_on: null,
        impact_productivity: true,
        impact_quality: false,
        impact_safety: false
      },
      steps: []
    }
  ],
  kaizenNotesResponses: [
    {
      id: 1457,
      response: null,
      question: 'Which problems are you trying to solve?',
      type: 'text_area',
      options: null
    },
    {
      id: 1458,
      response: null,
      question: 'Are the recommendations generated by the app helpful?',
      type: 'radio_button',
      options: ['Yes', 'No']
    },
    {
      id: 1459,
      response: null,
      question: "Engineer's notes on generated recommendations",
      type: 'text_area',
      options: null
    },
    {
      id: 1460,
      response: null,
      question: 'Have the recommendations been implemented?',
      type: 'radio_button',
      options: ['Yes, Largely', 'Yes, Partially', 'No']
    },
    {
      id: 1461,
      response: null,
      question: 'Observations after improvements / Benefits of Kaizen event',
      type: 'text_area',
      options: null
    },
    {
      id: 1462,
      response: null,
      question: "Were there any useful ideas which weren't recommended by the app?",
      type: 'text_area',
      options: null
    },
    {
      id: 1463,
      response: null,
      question: 'Miscellaneous Notes',
      type: 'text_area',
      options: null
    },
    {
      id: 1464,
      response: null,
      question: 'File Upload',
      type: 'file',
      options: null
    }
  ],
  // need to change this url
  motionEconomyImage: ASSETS.TOUR.STATION_DESIGN.MOTION_ECONOMY_IMAGE,
  summarizedSuggestions: [
    'Based on the provided data, there are several suggestions that can be made to improve the manufacturing process:',
    '1. Minimize unnecessary non value-add steps: The assessment for Step 3 is labeled as "Necessary non value-add". This suggests that there may be steps in the process that are necessary but do not add value to the final product. Identify such steps and find ways to minimize their impact on the overall process to shorten the manufacturing time.',
    '2. Reduce haphazard hand motion: The hand motion type for Steps 5, 6, and 7 are labeled as "haphazard". This indicates that there may be inefficiencies in the way the worker is moving their hands during these steps, leading to slower manufacturing times. Finding ways to streamline these motions, such as using jigs or fixtures, can help to make the process more efficient.',
    '3. Optimize hand distance travelled: The distance travelled for Steps 5, 6, and 7 are relatively large compared to other steps. This indicates that there may be opportunities to optimize the layout of the work environment and improve the ergonomics for the worker to minimize the amount of hand travel required for these steps.',
    '4. Identify potential automation opportunities: Analyzing the therblig actions for each step can help to identify opportunities for automation. For example, Steps 3, 4, and 5 involve a lot of movement and manipulation of objects. Consider how automation and robotics can be used to perform these tasks more efficiently and precisely.',
    '5. Improve worker training: Given the different assessment types for each step, it may be beneficial to assess worker performance and provide training to optimize their movements and increase efficiency.',
    "6. Regularly review and optimize the manufacturing process: Lastly, it's important to continuously review and optimize the manufacturing process to identify and address any inefficiencies. By analyzing data, identifying potential improvements, and implementing changes, the overall efficiency of the manufacturing process can be improved.",
    "For step_3(Pick 3 components from Bin 3): \n- Consider analyzing the actions that are labeled as 'Necessary non value-add' and see if any of them can be optimized or eliminated to improve efficiency.",
    "For step_4(Place 3 components and pick roller):\n- As the comments indicate that this step is 'Value-add', it might be worth considering if any tasks or actions can be added to further increase the value of this step.",
    "For step_5(Install roller):\n- Since this step has a mix of both 'Value-add' and 'Necessary non value-add' actions, it would be beneficial to analyze the processes and identify tasks that can be optimized or eliminated to improve efficiency and reduce wasted time.",
    'For step_6(Pick 3 components from Bin 2):\n- There are very few comments for this step, so it might be worth re-evaluating the processes at this step to see if there are any areas for improvement.',
    "For step_7(Place screw and hand tighten):\n- Similar to step_4(Place 3 components and pick roller), as the comments indicate that this step is mainly 'Value-add', consider if there any additional actions or tasks that can be added to increase the value of this step.",
    'For step_8(Hand tighten screw):\n- Since there is only one comment for this step, it might be worth doing an analysis to see if there are any potential areas for improvement or optimization.',
    "For step_1(Place unit on the table and Pick plate) and step_2(Install plate and add 1 screw):\n- As both of these steps are labeled as 'Value-add', it might be worth doing an analysis to identify any potential tasks or actions that can be added or optimized to increase the value of these steps."
  ],
  stationLayoutSuggestion: {
    totalCycleTime: '66.17 (s)',
    totalValueAddTime: '61.11 (s)',
    valueAddPercentage: '92.4%',
    medianOfCycleTimes: '65(s)',
    actual_cycle_time: '62 ± 4.76 (s)',
    no_of_steps: 8
  },
  stepsTimePerCycle: [
    {
      name: 'Hand tighten screw',
      data: [3.42]
    },
    {
      name: 'Place screw and hand tighten',
      data: [9.02]
    },
    {
      name: 'Pick 3 components from Bin 2',
      data: [9.05]
    },
    {
      name: 'Install roller',
      data: [16.39]
    },
    {
      name: 'Place 3 components and pick roller',
      data: [4.16]
    },
    {
      name: 'Pick 3 components from Bin 3',
      data: [2.82]
    },
    {
      name: 'Install plate and add 1 screw',
      data: [12.67]
    },
    {
      name: 'Place unit on the table and Pick plate',
      data: [6.4]
    }
  ],
  valueAddedPieChart: [
    ['Necessary non value-add', 4.25531914893617],
    ['Value-add', 92.35055724417427],
    ['Non value-add', 0]
  ],
  segmentationDatForSuggestions: [
    {
      id: 13555,
      name: 'teest',
      segment_start: 0.3153153153153153,
      segment_end: 4.864864864864865,
      step_index: 0,
      stopclock_time: null,
      action_type: 'Manual',
      value_type: 'Non value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 458,
        cycle_no: 0,
        cycle_start_frame_no: 0,
        cycle_end_frame_no: 1332,
        is_master: true,
        station: 1328
      },
      parent_step: null,
      predecessor: [
        {
          id: 13306,
          name: 'fix headlight',
          segment_start: 134,
          segment_end: 239,
          step_index: 1,
          stopclock_time: null,
          action_type: 'Manual',
          value_type: 'Non value-add',
          value_type_by_user: false,
          work_cycle: 428,
          parent_step: null,
          predecessor: [13305]
        }
      ],
      step_action_association: [
        {
          id: 4713,
          value_type: 'Non value-add',
          step: 13555,
          action: 18,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 4713,
          value_type: 'Non value-add',
          step: 13555,
          action: 18,
          answers: []
        }
      ],
      actions: ['Avoidable Delay'],
      assessment: 'Non value-add',
      segmentDuration: 4.55,
      avg_time: 4.55,
      step_std: 0.0004504504504501128,
      actionsSuggestions: [
        {
          id: 4713,
          value_type: 'Non value-add',
          step: 13555,
          action: 18,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      }
    },
    {
      id: 13556,
      name: 'eww',
      segment_start: 4.90990990990991,
      segment_end: 12.612612612612613,
      step_index: 1,
      stopclock_time: null,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 458,
        cycle_no: 0,
        cycle_start_frame_no: 0,
        cycle_end_frame_no: 1332,
        is_master: true,
        station: 1328
      },
      parent_step: null,
      predecessor: [
        {
          id: 13555,
          name: 'teest',
          segment_start: 7,
          segment_end: 108,
          step_index: 0,
          stopclock_time: null,
          action_type: 'Manual',
          value_type: 'Non value-add',
          value_type_by_user: false,
          work_cycle: 458,
          parent_step: null,
          predecessor: [13306]
        }
      ],
      step_action_association: [
        {
          id: 4715,
          value_type: 'Value-add',
          step: 13556,
          action: 3,
          answers: []
        },
        {
          id: 4714,
          value_type: 'Value-add',
          step: 13556,
          action: 4,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 4715,
          value_type: 'Value-add',
          step: 13556,
          action: 3,
          answers: []
        },
        {
          id: 4714,
          value_type: 'Value-add',
          step: 13556,
          action: 4,
          answers: []
        }
      ],
      actions: ['Reach and Move', 'Grasp'],
      assessment: 'Value-add',
      segmentDuration: 7.7,
      avg_time: 7.7,
      step_std: 0.0027027027027033412,
      actionsSuggestions: [
        {
          id: 4715,
          value_type: 'Value-add',
          step: 13556,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 4714,
          value_type: 'Value-add',
          step: 13556,
          action: 4,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      }
    },
    {
      id: 13557,
      name: 'www',
      segment_start: 12.657657657657658,
      segment_end: 31.98198198198198,
      step_index: 2,
      stopclock_time: null,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 458,
        cycle_no: 0,
        cycle_start_frame_no: 0,
        cycle_end_frame_no: 1332,
        is_master: true,
        station: 1328
      },
      parent_step: null,
      predecessor: [
        {
          id: 13556,
          name: 'eww',
          segment_start: 109,
          segment_end: 280,
          step_index: 1,
          stopclock_time: null,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 458,
          parent_step: null,
          predecessor: [13555]
        }
      ],
      step_action_association: [
        {
          id: 4717,
          value_type: 'Value-add',
          step: 13557,
          action: 3,
          answers: []
        },
        {
          id: 4716,
          value_type: 'Value-add',
          step: 13557,
          action: 4,
          answers: []
        },
        {
          id: 4718,
          value_type: 'Value-add',
          step: 13557,
          action: 7,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 4717,
          value_type: 'Value-add',
          step: 13557,
          action: 3,
          answers: []
        },
        {
          id: 4716,
          value_type: 'Value-add',
          step: 13557,
          action: 4,
          answers: []
        },
        {
          id: 4718,
          value_type: 'Value-add',
          step: 13557,
          action: 7,
          answers: []
        }
      ],
      actions: ['Reach and Move', 'Grasp', 'Use'],
      assessment: 'Value-add',
      segmentDuration: 19.32,
      avg_time: 19.32,
      step_std: 0.004324324324322504,
      actionsSuggestions: [
        {
          id: 4717,
          value_type: 'Value-add',
          step: 13557,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 4716,
          value_type: 'Value-add',
          step: 13557,
          action: 4,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 4718,
          value_type: 'Value-add',
          step: 13557,
          action: 7,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      }
    },
    {
      id: 13558,
      name: 'ww',
      segment_start: 32.027027027027025,
      segment_end: 52.83783783783784,
      step_index: 3,
      stopclock_time: null,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 458,
        cycle_no: 0,
        cycle_start_frame_no: 0,
        cycle_end_frame_no: 1332,
        is_master: true,
        station: 1328
      },
      parent_step: null,
      predecessor: [
        {
          id: 13557,
          name: 'www',
          segment_start: 281,
          segment_end: 710,
          step_index: 2,
          stopclock_time: null,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 458,
          parent_step: null,
          predecessor: [13556]
        }
      ],
      step_action_association: [
        {
          id: 4719,
          value_type: 'Value-add',
          step: 13558,
          action: 3,
          answers: []
        },
        {
          id: 4720,
          value_type: 'Value-add',
          step: 13558,
          action: 7,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 4719,
          value_type: 'Value-add',
          step: 13558,
          action: 3,
          answers: []
        },
        {
          id: 4720,
          value_type: 'Value-add',
          step: 13558,
          action: 7,
          answers: []
        }
      ],
      actions: ['Reach and Move', 'Use'],
      assessment: 'Value-add',
      segmentDuration: 20.81,
      avg_time: 20.81,
      step_std: 0.0008108108108153544,
      actionsSuggestions: [
        {
          id: 4719,
          value_type: 'Value-add',
          step: 13558,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 4720,
          value_type: 'Value-add',
          step: 13558,
          action: 7,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      }
    },
    {
      id: 13559,
      name: 'er',
      segment_start: 52.88288288288288,
      segment_end: 59.95495495495496,
      step_index: 4,
      stopclock_time: null,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 458,
        cycle_no: 0,
        cycle_start_frame_no: 0,
        cycle_end_frame_no: 1332,
        is_master: true,
        station: 1328
      },
      parent_step: null,
      predecessor: [
        {
          id: 13558,
          name: 'ww',
          segment_start: 711,
          segment_end: 1173,
          step_index: 3,
          stopclock_time: null,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 458,
          parent_step: null,
          predecessor: [13557]
        }
      ],
      step_action_association: [
        {
          id: 4721,
          value_type: 'Value-add',
          step: 13559,
          action: 3,
          answers: []
        }
      ],
      actions_suggestions: [
        {
          id: 4721,
          value_type: 'Value-add',
          step: 13559,
          action: 3,
          answers: []
        }
      ],
      actions: ['Reach and Move'],
      assessment: 'Value-add',
      segmentDuration: 7.07,
      avg_time: 7.07,
      step_std: 0.0020720720720746044,
      actionsSuggestions: [
        {
          id: 4721,
          value_type: 'Value-add',
          step: 13559,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      }
    }
  ],
  ergoTableData: [
    {
      zone: 'Zone 1',
      region: 'A',
      percentage: '29.2'
    },
    {
      zone: 'Zone 1',
      region: 'B',
      percentage: '2.9'
    },
    {
      zone: 'Zone 1',
      region: 'C',
      percentage: '33.1'
    },
    {
      zone: 'Zone 2',
      region: 'D',
      percentage: '15.0'
    },
    {
      zone: 'Zone 2',
      region: 'E',
      percentage: '0.2'
    },
    {
      zone: 'Zone 2',
      region: 'F',
      percentage: '2.1'
    },
    {
      zone: 'Zone 3',
      region: 'G',
      percentage: '0.4'
    },
    {
      zone: 'Zone 3',
      region: 'H',
      percentage: '0.2'
    },
    {
      zone: 'Zone 3',
      region: 'I',
      percentage: '0.4'
    },
    {
      zone: 'Zone 4',
      region: 'J',
      percentage: '12.0'
    },
    {
      zone: 'Zone 4',
      region: 'K',
      percentage: '4.1'
    },
    {
      zone: 'Zone 4',
      region: 'L',
      percentage: '0.4'
    }
  ],
  ergonomicsResult: [
    {
      suggestion: {
        suggestion:
          "Based on our analysis, Zones 1 and 2 account for 82.5% of hand occurrences, indicating that the most frequently used items are conveniently within the worker's reach. | Additionally, hand occurrences have been detected in regions J, K in Zone 4, which may necessitate a full extension of the worker's arm. It is recommended to move items from this region to regions B,E,F, G, H, I for improved ergonomics and worker safety. | Lastly, the regions A, C, D have an overall high distribution in Zone 1 and 2 which can be redistributed into the regions B, E, F. | ",
        percentages: {
          'Zone 1': {
            A: 29.2,
            B: 2.9,
            C: 33.1
          },
          'Zone 2': {
            D: 15,
            E: 0.2,
            F: 2.1
          },
          'Zone 3': {
            G: 0.4,
            H: 0.2,
            I: 0.4
          },
          'Zone 4': {
            J: 12,
            K: 4.1,
            L: 0.4
          }
        },
        recommendations: [
          {
            source_region: ['J', 'K'],
            dest_region: ['B', 'E', 'F', 'G', 'H', 'I']
          },
          {
            source_region: ['A', 'C', 'D'],
            dest_region: ['B', 'E', 'F']
          }
        ]
      },
      image_path: 'station_analysis/183/ergonomics/image_0.jpg',
      image: ASSETS.TOUR.STATION_DESIGN.ERGONOMICS_RESULT_IMAGE
    }
  ],
  ergonomicsResultData: {
    'Zone 1': {
      A: 29.2,
      B: 2.9,
      C: 33.1
    },
    'Zone 2': {
      D: 15,
      E: 0.2,
      F: 2.1
    },
    'Zone 3': {
      G: 0.4,
      H: 0.2,
      I: 0.4
    },
    'Zone 4': {
      J: 12,
      K: 4.1,
      L: 0.4
    }
  },
  steps: [
    {
      id: 11147,
      name: 'Place unit on the table and Pick plate',
      segment_start: 1.9778746228628898,
      segment_end: 8.380824673147838,
      step_index: 0,
      stopclock_time: 6.4,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: true,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11146,
          name: 'Hand tighten screw',
          segment_start: 1872,
          segment_end: 1974,
          step_index: 7,
          stopclock_time: 3.42,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11144]
        }
      ],
      step_action_association: [
        {
          id: 3486,
          value_type: 'Value-add',
          step: 11147,
          action: 3
        }
      ],
      actions_suggestions: [
        {
          id: 3486,
          value_type: 'Value-add',
          step: 11147,
          action: 3,
          answers: [
            {
              id: 414,
              answer: true,
              question: 1,
              step_action: 3486
            }
          ],
          actions_suggestions: [
            {
              suggestion: 'Eliminate this step.',
              cost_saving_percentage: 80
            }
          ]
        }
      ],
      actions: ['Reach and Move'],
      assessment: 'Value-add',
      segmentDuration: 6.4,
      actionsSuggestions: [
        {
          id: 3486,
          value_type: 'Value-add',
          step: 11147,
          action: 3,
          answers: [
            {
              id: 414,
              answer: true,
              question: 1,
              step_action: 3486
            }
          ],
          suggestion: 'Eliminate this step.',
          cost_saving_percentage: 80,
          potential_savings: '5.12 sec, $4412 per year',
          timeSavedPerCycle: 5.122360040227959,
          totalAmountSavedPerYear: 4412
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image: ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE['1'],
        total_distance: 2126.743062413158
      }
    },
    {
      id: 11148,
      name: 'Install plate and add 1 screw',
      segment_start: 8.447871270533021,
      segment_end: 21.119678176332553,
      step_index: 1,
      stopclock_time: 12.67,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11147,
          name: 'Place unit on the table and Pick plate',
          segment_start: 59,
          segment_end: 250,
          step_index: 0,
          stopclock_time: 6.4,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: true,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11146]
        }
      ],
      step_action_association: [
        {
          id: 3488,
          value_type: 'Value-add',
          step: 11148,
          action: 3
        },
        {
          id: 3487,
          value_type: 'Value-add',
          step: 11148,
          action: 4
        },
        {
          id: 3489,
          value_type: 'Value-add',
          step: 11148,
          action: 7
        }
      ],
      actions_suggestions: [
        {
          id: 3488,
          value_type: 'Value-add',
          step: 11148,
          action: 3,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3487,
          value_type: 'Value-add',
          step: 11148,
          action: 4,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3489,
          value_type: 'Value-add',
          step: 11148,
          action: 7,
          answers: [],
          actions_suggestions: []
        }
      ],
      actions: ['Reach and Move', 'Grasp', 'Use'],
      assessment: 'Value-add',
      segmentDuration: 12.67,
      actionsSuggestions: [
        {
          id: 3488,
          value_type: 'Value-add',
          step: 11148,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3487,
          value_type: 'Value-add',
          step: 11148,
          action: 4,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3489,
          value_type: 'Value-add',
          step: 11148,
          action: 7,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image: ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE['2'],
        total_distance: 4076.475408479735
      }
    },
    {
      id: 11140,
      name: 'Pick 3 components from Bin 3',
      segment_start: 21.153201475025142,
      segment_end: 23.969158565202818,
      step_index: 2,
      stopclock_time: 2.82,
      action_type: 'Manual',
      value_type: 'Necessary non value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 8353,
          name: 'fit comp 1',
          segment_start: 5364,
          segment_end: 5558,
          step_index: 10,
          stopclock_time: 6.48,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 44,
          parent_step: null,
          predecessor: [8351]
        }
      ],
      step_action_association: [
        {
          id: 3468,
          value_type: null,
          step: 11140,
          action: 3
        },
        {
          id: 3467,
          value_type: null,
          step: 11140,
          action: 4
        },
        {
          id: 3469,
          value_type: null,
          step: 11140,
          action: 5
        },
        {
          id: 3450,
          value_type: 'Necessary non value-add',
          step: 11140,
          action: 8
        }
      ],
      actions_suggestions: [
        {
          id: 3468,
          value_type: null,
          step: 11140,
          action: 3,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3467,
          value_type: null,
          step: 11140,
          action: 4,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3469,
          value_type: null,
          step: 11140,
          action: 5,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3450,
          value_type: 'Necessary non value-add',
          step: 11140,
          action: 8,
          answers: [],
          actions_suggestions: []
        }
      ],
      actions: ['Reach and Move', 'Grasp', 'Release Load', 'Position/Orient'],
      assessment: 'Necessary non value-add',
      segmentDuration: 2.82,
      actionsSuggestions: [
        {
          id: 3468,
          value_type: null,
          step: 11140,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3467,
          value_type: null,
          step: 11140,
          action: 4,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3469,
          value_type: null,
          step: 11140,
          action: 5,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3450,
          value_type: 'Necessary non value-add',
          step: 11140,
          action: 8,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image: ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE['3'],
        total_distance: 290.7080524788499
      }
    },
    {
      id: 11141,
      name: 'Place 3 components and pick roller',
      segment_start: 24.002681863895408,
      segment_end: 28.159570901776735,
      step_index: 3,
      stopclock_time: 4.16,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11140,
          name: 'Pick 3 components from Bin 3',
          segment_start: 631,
          segment_end: 715,
          step_index: 2,
          stopclock_time: 2.82,
          action_type: 'Manual',
          value_type: 'Necessary non value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [8353]
        }
      ],
      step_action_association: [
        {
          id: 3451,
          value_type: 'Value-add',
          step: 11141,
          action: 4
        },
        {
          id: 3470,
          value_type: null,
          step: 11141,
          action: 5
        },
        {
          id: 3471,
          value_type: null,
          step: 11141,
          action: 8
        },
        {
          id: 3472,
          value_type: null,
          step: 11141,
          action: 12
        }
      ],
      actions_suggestions: [
        {
          id: 3451,
          value_type: 'Value-add',
          step: 11141,
          action: 4,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3470,
          value_type: null,
          step: 11141,
          action: 5,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3471,
          value_type: null,
          step: 11141,
          action: 8,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3472,
          value_type: null,
          step: 11141,
          action: 12,
          answers: [],
          actions_suggestions: []
        }
      ],
      actions: ['Grasp', 'Release Load', 'Position/Orient', 'Assemble'],
      assessment: 'Value-add',
      segmentDuration: 4.16,
      actionsSuggestions: [
        {
          id: 3451,
          value_type: 'Value-add',
          step: 11141,
          action: 4,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3470,
          value_type: null,
          step: 11141,
          action: 5,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3471,
          value_type: null,
          step: 11141,
          action: 8,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3472,
          value_type: null,
          step: 11141,
          action: 12,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image:ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE['4'],
        total_distance: 153.42202780073785
      }
    },
    {
      id: 11142,
      name: 'Install roller',
      segment_start: 28.19309420046933,
      segment_end: 44.5859872611465,
      step_index: 4,
      stopclock_time: 16.39,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11140,
          name: 'Pick 3 components from Bin 3',
          segment_start: 631,
          segment_end: 715,
          step_index: 2,
          stopclock_time: 2.82,
          action_type: 'Manual',
          value_type: 'Necessary non value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [8353]
        }
      ],
      step_action_association: [
        {
          id: 3453,
          value_type: 'Value-add',
          step: 11142,
          action: 3
        },
        {
          id: 3452,
          value_type: 'Value-add',
          step: 11142,
          action: 4
        },
        {
          id: 3454,
          value_type: 'Value-add',
          step: 11142,
          action: 7
        },
        {
          id: 3455,
          value_type: 'Necessary non value-add',
          step: 11142,
          action: 8
        },
        {
          id: 3473,
          value_type: null,
          step: 11142,
          action: 12
        }
      ],
      actions_suggestions: [
        {
          id: 3453,
          value_type: 'Value-add',
          step: 11142,
          action: 3,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3452,
          value_type: 'Value-add',
          step: 11142,
          action: 4,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3454,
          value_type: 'Value-add',
          step: 11142,
          action: 7,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3455,
          value_type: 'Necessary non value-add',
          step: 11142,
          action: 8,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3473,
          value_type: null,
          step: 11142,
          action: 12,
          answers: [],
          actions_suggestions: []
        }
      ],
      actions: ['Reach and Move', 'Grasp', 'Use', 'Position/Orient', 'Assemble'],
      assessment: 'Value-add',
      segmentDuration: 16.39,
      actionsSuggestions: [
        {
          id: 3453,
          value_type: 'Value-add',
          step: 11142,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3452,
          value_type: 'Value-add',
          step: 11142,
          action: 4,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3454,
          value_type: 'Value-add',
          step: 11142,
          action: 7,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3455,
          value_type: 'Necessary non value-add',
          step: 11142,
          action: 8,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3473,
          value_type: null,
          step: 11142,
          action: 12,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image: ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE[5],
        total_distance: 22297.039093788426
      }
    },
    {
      id: 11143,
      name: 'Pick 3 components from Bin 2',
      segment_start: 44.61951055983909,
      segment_end: 53.67080120683875,
      step_index: 5,
      stopclock_time: 9.05,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11141,
          name: 'Place 3 components and pick roller',
          segment_start: 716,
          segment_end: 840,
          step_index: 3,
          stopclock_time: 4.16,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11140]
        }
      ],
      step_action_association: [
        {
          id: 3456,
          value_type: 'Value-add',
          step: 11143,
          action: 3
        },
        {
          id: 3474,
          value_type: null,
          step: 11143,
          action: 6
        },
        {
          id: 3475,
          value_type: null,
          step: 11143,
          action: 9
        }
      ],
      actions_suggestions: [
        {
          id: 3456,
          value_type: 'Value-add',
          step: 11143,
          action: 3,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3474,
          value_type: null,
          step: 11143,
          action: 6,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3475,
          value_type: null,
          step: 11143,
          action: 9,
          answers: [],
          actions_suggestions: []
        }
      ],
      actions: ['Reach and Move', 'Pre-Position', 'Inspect'],
      assessment: 'Value-add',
      segmentDuration: 9.05,
      actionsSuggestions: [
        {
          id: 3456,
          value_type: 'Value-add',
          step: 11143,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3474,
          value_type: null,
          step: 11143,
          action: 6,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3475,
          value_type: null,
          step: 11143,
          action: 9,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image:ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE['6'],
        total_distance: 728.43043988214
      }
    },
    {
      id: 11144,
      name: 'Place screw and hand tighten',
      segment_start: 53.704324505531346,
      segment_end: 62.72209185383842,
      step_index: 6,
      stopclock_time: 9.02,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11143,
          name: 'Pick 3 components from Bin 2',
          segment_start: 1331,
          segment_end: 1601,
          step_index: 5,
          stopclock_time: 9.05,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11141]
        }
      ],
      step_action_association: [
        {
          id: 3458,
          value_type: 'Value-add',
          step: 11144,
          action: 3
        },
        {
          id: 3457,
          value_type: 'Value-add',
          step: 11144,
          action: 4
        },
        {
          id: 3477,
          value_type: null,
          step: 11144,
          action: 5
        },
        {
          id: 3459,
          value_type: 'Value-add',
          step: 11144,
          action: 7
        },
        {
          id: 3476,
          value_type: null,
          step: 11144,
          action: 8
        }
      ],
      actions_suggestions: [
        {
          id: 3458,
          value_type: 'Value-add',
          step: 11144,
          action: 3,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3457,
          value_type: 'Value-add',
          step: 11144,
          action: 4,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3477,
          value_type: null,
          step: 11144,
          action: 5,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3459,
          value_type: 'Value-add',
          step: 11144,
          action: 7,
          answers: [],
          actions_suggestions: []
        },
        {
          id: 3476,
          value_type: null,
          step: 11144,
          action: 8,
          answers: [],
          actions_suggestions: []
        }
      ],
      actions: ['Reach and Move', 'Grasp', 'Release Load', 'Use', 'Position/Orient'],
      assessment: 'Value-add',
      segmentDuration: 9.02,
      actionsSuggestions: [
        {
          id: 3458,
          value_type: 'Value-add',
          step: 11144,
          action: 3,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3457,
          value_type: 'Value-add',
          step: 11144,
          action: 4,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3477,
          value_type: null,
          step: 11144,
          action: 5,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3459,
          value_type: 'Value-add',
          step: 11144,
          action: 7,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        {
          id: 3476,
          value_type: null,
          step: 11144,
          action: 8,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image: ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE['7'],
        total_distance: 3192.2237962816685
      }
    },
    {
      id: 11146,
      name: 'Hand tighten screw',
      segment_start: 62.755615152531014,
      segment_end: 66.17499161917533,
      step_index: 7,
      stopclock_time: 3.42,
      action_type: 'Manual',
      value_type: 'Value-add',
      value_type_by_user: false,
      work_cycle: {
        id: 201,
        cycle_no: 0,
        cycle_start_frame_no: 59,
        cycle_end_frame_no: 1976,
        is_master: true,
        station: 1138
      },
      parent_step: null,
      predecessor: [
        {
          id: 11144,
          name: 'Place screw and hand tighten',
          segment_start: 1602,
          segment_end: 1871,
          step_index: 6,
          stopclock_time: 9.02,
          action_type: 'Manual',
          value_type: 'Value-add',
          value_type_by_user: false,
          work_cycle: 201,
          parent_step: null,
          predecessor: [11143]
        }
      ],
      step_action_association: [
        {
          id: 3484,
          value_type: 'Value-add',
          step: 11146,
          action: 7
        }
      ],
      actions_suggestions: [
        {
          id: 3484,
          value_type: 'Value-add',
          step: 11146,
          action: 7,
          answers: [],
          actions_suggestions: []
        }
      ],
      actions: ['Use'],
      assessment: 'Value-add',
      segmentDuration: 3.42,
      actionsSuggestions: [
        {
          id: 3484,
          value_type: 'Value-add',
          step: 11146,
          action: 7,
          answers: [],
          potential_savings: '0.00 sec, $0 per year',
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        }
      ],
      motionEconomy: {
        motion: {
          type: 'Economical Motion'
        },
        potentialSavings: {
          timeSavedPerCycle: 0,
          totalAmountSavedPerYear: 0
        },
        image: ASSETS.TOUR.STATION_DESIGN.STEPS.MOTION_ECONOMY_IMAGE['8'],
        total_distance: 257.1313353079496
      }
    }
  ],
  cyclesDurations: {
    id: 201,
    cycle_no: 0,
    is_master: true,
    station: 1138,
    segment_start: 1.9778746228628898,
    segment_end: 66.24203821656052,
    seg_time: 65
  }
}

export const dummyStudy = {
  id: 0,
  created_by: 'John Doe',
  time_created: '03/11/2024',
  study_name: null,
  part_no: 'Gearbox',
  progress: 0,
  processes: [
    {
      id: 2346,
      progress: 100,
      description: '',
      process: {
        id: 1,
        name: 'Segmentation'
      },
      status: {
        id: 2,
        name: 'Finished'
      },
      completed_status: {
        id: 2,
        name: 'Finished'
      }
    },
    {
      id: 2347,
      progress: 100,
      description: '',
      process: {
        id: 2,
        name: 'Classification'
      },
      status: {
        id: 2,
        name: 'Finished'
      },
      completed_status: {
        id: 2,
        name: 'Finished'
      }
    },
    {
      id: 2348,
      progress: 100,
      description: '',
      process: {
        id: 3,
        name: 'Hand Tracking'
      },
      status: {
        id: 2,
        name: 'Finished'
      },
      completed_status: {
        id: 2,
        name: 'Finished'
      }
    },
    {
      id: 2349,
      progress: 100,
      description: '',
      process: {
        id: 4,
        name: 'Ergonomics'
      },
      status: {
        id: 2,
        name: 'Finished'
      },
      completed_status: {
        id: 2,
        name: 'Finished'
      }
    },
    {
      id: 2350,
      progress: 100,
      description: '',
      process: {
        id: 5,
        name: 'Segments Mapping'
      },
      status: {
        id: 2,
        name: 'Finished'
      },
      completed_status: {
        id: 2,
        name: 'Finished'
      }
    }
  ],
  thumbnail: ASSETS.TOUR.STATION_DESIGN.THUMBNAIL,
  no_of_steps: '6',
  station_id: 'Spring Assembly',
  isCompleted: true,
  isProcessesRemaining: false,
  status:'Completed',
  isNotStarted: false,
  isFailed: false
}